// @ts-check

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Page,
  BlockStack,
  Button,
  InlineStack,
} from "@shopify/polaris";
import { ExportIcon } from "@shopify/polaris-icons";

import { usePostHog } from "posthog-js/react";

import { UtmSetsTable } from "components/UtmSetsTable/UtmSetsTable";
import { LockableCard } from "components/cards/LockableCard/LockableCard";
import { FetchOrdersControls } from "components/FetchOrderControls/FetchOrdersControls";
import { SyncingBanner } from "components/SyncingBanner/SyncingBanner";

import { useGlobalContext } from "context/GlobalContext";

export default function UtmSetsPage() {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const { locked } = useGlobalContext();

  useEffect(() => {
    posthog.capture("$pageview");
  }, []);

  const onExportClick = () => {
    navigate("/utm-sets/export");
  };

  return (
    <Page
      title="UTM Sets"
      subtitle="Every set of UTM parameters your customers have placed an order with"
      fullWidth
    >
      <Layout>
        <Layout.Section>
          <BlockStack gap="400">
            <SyncingBanner />

            <BlockStack gap="200">
              <InlineStack gap="200" align="space-between">
                <FetchOrdersControls />

                <Button
                  variant="secondary"
                  icon={ExportIcon}
                  onClick={onExportClick}
                >
                  Export UTM sets
                </Button>
              </InlineStack>

              <LockableCard locked={locked}>
                <UtmSetsTable />
              </LockableCard>
            </BlockStack>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
